// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyStateNiches {
  display: flex;
  gap: 30px;
  justify-content: center;
  padding: 32px 0;
  grid-column: 1/4;
}
.EmptyStateNiches-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  justify-content: center;
  width: 458px;
  padding-top: 10px;
}
.EmptyStateNiches-content h3 {
  font-weight: 400;
}
.EmptyStateNiches-content p {
  color: #4c5567;
  color: var(--color_neutral_800, #4c5567);
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/modules/niche/niche-empty-state/niche-empty-state.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;AACJ;AACI;EACE,gBAAA;AACN;AAEI;EACE,cAAA;EAAA,wCAAA;EACA,eAAA;AAAN","sourcesContent":[".EmptyStateNiches {\n  display: flex;\n  gap: 30px;\n  justify-content: center;\n  padding: 32px 0;\n  grid-column: 1/4;\n\n  &-content {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-start;\n    justify-content: center;\n    width: 458px;\n    padding-top: 10px;\n\n    h3 {\n      font-weight: 400;\n    }\n\n    p {\n      color: var(--color_neutral_800, #4c5567);\n      font-size: 14px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
